import { render, staticRenderFns } from "./DiffEntry.vue?vue&type=template&id=9e9a854c&scoped=true&"
import script from "./DiffEntry.vue?vue&type=script&lang=ts&"
export * from "./DiffEntry.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e9a854c",
  null
  
)

export default component.exports